export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betflip-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betflip-themeWrapLive" */'./LiveThemeImporter'),
  },
};
